import React, { useMemo, useState, useEffect } from 'react';
import ProductImages from './../ProductDetail/ProductImages';
import { useDispatch, useSelector } from 'react-redux';
import { FastField, Form, Formik } from 'formik';
import { trackEvent } from '../../components/Tracking/Matomo';
import { addReifen } from '../../../modules/actions/standort/session/cart';
import Currency from '../../../helpers/currency';
import { taxLabel } from '../../../helpers/taxHelper';
import { speedIndexToSpeed } from '../../../helpers/tiresHelper';
import Button from '../../components/form-elements/Button';
import TireInformationModal from '../../components/Tires/TireInformationModal';
import TireEnergyLabelLinks from '../Tires/TireEnergyLabelLinks';
import Anchor from '../../components/form-elements/Anchor';
import LegacyTireLabel from '../../components/Tires/LegacyTireLabel';
import { InternalLink } from '../../components/form-elements/Link';
import { markenStandortSelector } from '../../../modules/selectors/standort/markenStandort';
import classnames from 'classnames';
import QuantityInput from '../ProductDetail/QuantityInput';
import StandortLink from '../../components/VHost/StandortLink';
import { ExternalLink } from '../../components/form-elements/Link';
function QuantityBox({ tire, online: isOnline, lieferweg, price, isFreeShipping, setSelect, isSelected, quantity, isOfferActive, isNoa }) {
    let aktionsPreis = tire.aktionsPreis ?? null;
    let aktionsPreisPickup = tire.aktionsPreisPickup ?? null;

    return (
        <div >
            <div onClick={() => setSelect(isOnline)} className={classnames('uk-width-1 uk-margin-small', isSelected ? "uk-background-muted quality-box-card" : "uk-border uk-border-muted quality-box-card")} style={{ cursor: 'pointer' }}>
                <div className="uk-flex uk-flex-between">
                    <div className="uk-text-small uk-text-muted uk-flex uk-flex-start">
                        <div className="uk-width-auto" style={{ paddingTop: "10px" }}>
                            <input type="radio" name={`lieferweg-${tire.id}`} className="uk-radio uk-margin-right" checked={isSelected} onChange={() => { }} />

                        </div>
                        <div className='uk-flex uk-flex-column uk-text-left'>
                            <span className='uk-text-left uk-text-bold' style={{ fontSize: '1.375rem' }}>{isOnline ? 'Lieferung' : 'Abholung'}</span>
                            <div className='uk-text-left uk-margin-small'>
                                Preis inkl. {taxLabel()} MwSt.
                            </div>
                            {isOnline && (
                                isFreeShipping ?
                                    <div>
                                        <InternalLink to="/versandkosten" ariaLabel="Informationen zu Versandkosten"><u className='uk-text-bold uk-text-decoration-none' style={{ color: "#128001" }}>Versandkostenfrei</u></InternalLink>
                                    </div>
                                    :
                                    <div>
                                        zzgl. <Currency quantity={lieferweg?.versandkosten?.pauschale1} />{' '}
                                        <StandortLink
                                            className="uk-link focus"
                                            to="/lieferUndVersand"
                                            ariaLabel="Informationen zu Versandkosten"
                                        >
                                            <u>Versandkosten</u>
                                        </StandortLink>
                                    </div>
                            )}
                        </div>
                    </div>
                    {((!aktionsPreis && !aktionsPreisPickup) || !isOfferActive) &&
                        <span className="aps-price">
                            <Currency quantity={price * quantity} />
                        </span>
                    }

                    {(aktionsPreis && isOnline && isOfferActive) &&
                        <>
                            <div className="uk-width-2-3 uk-flex uk-flex-column uk-text-right uk-width-expand uk-padding-remove-left">
                                <div className="uk-flex uk-flex-middle uk-flex-column uk-flex-end">
                                    <div className="uk-width-auto uk-flex uk-flex-column uk-text-right uk-width-expand">
                                        <div className={classnames(isNoa ? "uk-flex uk-flex-end uk-flex-right noaOldPrice" : "uk-flex uk-flex-column uk-flex-middle uk-flex-right")}>
                                            <div className="uk-h6 aps-price-old uk-margin-remove-top uk-margin-remove-bottom uk-padding-remove-left uk-padding-remove-vertical">
                                                <span className="statt">statt </span>
                                                <span>
                                                    <Currency quantity={price * quantity} />
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <span className={classnames('aps-price uk-text-offer uk-margin-remove-top uk-margin-remove-bottom uk-flex uk-flex-middle uk-flex-center', { 'noaPrice': isNoa })}>
                                        {!isNoa && <span className='percentage uk-flex uk-flex-middle uk-flex-center' aria-label='rabattierter Artikel'>%</span>}
                                        <Currency quantity={aktionsPreis * quantity} />
                                    </span>
                                </div>
                            </div>
                        </>

                    }
                    {(aktionsPreisPickup && !isOnline && isOfferActive && price !== null) &&
                        <>
                            <div className="uk-width-2-3 uk-flex uk-flex-column uk-text-right uk-width-expand uk-padding-remove-left">
                                <div className="uk-flex uk-flex-middle uk-flex-column uk-flex-end">
                                    <div className="uk-width-auto uk-flex uk-flex-column uk-text-right uk-width-expand">
                                        <div className={classnames(isNoa ? "uk-flex uk-flex-end uk-flex-right noaOldPrice" : "uk-flex uk-flex-column uk-flex-middle uk-flex-right")}>
                                            <div className="uk-h6 aps-price-old uk-margin-remove-top uk-margin-remove-bottom uk-padding-remove-left uk-padding-remove-vertical">
                                                <span className="statt">statt </span>
                                                <span>
                                                    <Currency quantity={price * quantity} />
                                                </span>

                                            </div>
                                        </div>
                                    </div>
                                    <span className={classnames('aps-price uk-text-offer uk-margin-remove-top uk-margin-remove-bottom uk-flex uk-flex-middle uk-flex-center', { 'noaPrice': isNoa })}>
                                        {!isNoa && <span className='percentage uk-flex uk-flex-middle uk-flex-center' aria-label='rabattierter Artikel'>%</span>}
                                        <Currency quantity={aktionsPreisPickup * quantity} />
                                    </span>
                                </div>
                            </div>
                        </>
                    }
                </div>
            </div>
        </div>
    )
}

function MerklistenTireDetail({ tireDetail }) {
    const markenStandort = useSelector(markenStandortSelector);
    const online = Boolean(tireDetail?.onlineLieferweg);
    const to = tireDetail.href || `/${tireDetail.categories[0]}/${tireDetail.id || tireDetail.neutralKey}`;
    const [isOnline, setIsOnline] = useState(online && !markenStandort.isTechno);
    const isTecar = tireDetail?.hersteller === 'TECAR' || tireDetail?.freeShipping === true;
    const isNoa = markenStandort.gesellschafterNr === "035";
    const herstellerangaben = tireDetail?.herstellerangaben ? tireDetail?.herstellerangaben : null;
    const [isMobile, setIsMobile] = useState(null);
    const [quantity, setQuantity] = useState(1);
    const dispatch = useDispatch();

    const handleQuantityInputChange = (newQuantity) => {
        setQuantity(newQuantity);
    };

    const additionalInformation = tireDetail?.additionalInfo?.dotWare
        ? { label: `DOT: ${tireDetail.additionalInfo.dotWare}`, tooltip: 'DOT = Herstellungsjahr des Reifens' }
        : tireDetail?.additionalInfo?.herstellerGarantie
            ? { label: 'mit Herstellergarantie', tooltip: 'Spezielle Garantie des Herstellers' }
            : tireDetail?.additionalInfo?.demo
                ? {
                    label: 'DEMO-Reifen',
                    tooltip:
                        'Demontierte Reifen bis Max. 50km Laufleistung von Vorführ- oder Neufahrzeugen bzw. von Kompletträdern zur Winter/Sommer Saison',
                }
                : undefined;

    const onlinePrice = isOnline && tireDetail.aktionsPreis ? tireDetail.aktionsPreis : tireDetail.selectedBezugsquelle.onlineVK;
    const pickupPrice = !isOnline && tireDetail.aktionsPreisPickup ? tireDetail.aktionsPreisPickup : tireDetail.selectedBezugsquelle.vk_preis;

    function handleAddToCart({ quantity, buttonType }) {
        trackEvent({
            category: 'E-Commerce',
            action: 'Lege-in-Warenkorb',
            label: tireDetail.neutralKey,
            value: (isOnline ? onlinePrice : pickupPrice) * quantity * 100,
        });
        dispatch(
            addReifen({
                reifen: {
                    ...tireDetail,
                    selectedLieferweg: isOnline ? tireDetail.onlineLieferweg : tireDetail.pickupLieferweg,
                    selectedBezugsquelle: {
                        ...tireDetail.selectedBezugsquelle,
                        vk_preis: isOnline ? onlinePrice : pickupPrice,
                    },
                },
                quantity,
                buttonType
            })
        );
    }

    const soldOut = useMemo(() => {
        if (!tireDetail) return false;

        return (
            (tireDetail.stockkeeping && tireDetail.stock < 1 && tireDetail.stock !== null) ||
            tireDetail.soldOut
        );
    }, [tireDetail]);

    const handleSelect = (isOnline) => {
        if (isOnline) {
            setIsOnline(true)
        } else {
            setIsOnline(false);
            // Handle offline selection
        }
    };

    const isAB = tireDetail.isAB;

    const isOfferActive = (tireDetail.isDeliveryOfferActive && !isAB) || (tireDetail.isPickUpOfferActive && (isAB || tireDetail.additionalPickup));

    useEffect(() => {
        function handleResize() {
            setIsMobile(window.innerWidth < 640);
        }

        if (typeof window !== 'undefined') {
            handleResize();
        }

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [isMobile]);

    return (
        <>
            <div className='uk-section uk-section-default uk-section-small'>
                <div className="uk-container uk-margin-medium-top">
                    <InternalLink to={to}>
                        <h1 className="uk-margin-remove uk-text-left">
                            {tireDetail.hersteller} {tireDetail.profil} <span className="uk-text-muted">{tireDetail.bezeichnung}</span>
                        </h1>
                    </InternalLink>
                    <h2 className="uk-text-light uk-margin-remove uk-text-left">{tireDetail.warengruppe}</h2>
                    <p className='uk-text-left'>Artikelnummer: {tireDetail.selectedBezugsquelle.artNummer}</p>
                    <div className="uk-grid-small uk-child-width-1-2@s" data-uk-grid="">
                        <div>
                            <ProductImages variant={tireDetail} images={tireDetail.images || []} linkedTo={to} isOfferActive={isOfferActive} />
                            {herstellerangaben && !isMobile && (
                                <div className='uk-margin-large-bottom'>
                                    <span><strong>Herstellerangaben:</strong> </span>
                                    <span>
                                        {herstellerangaben?.firma ? `${herstellerangaben?.firma} | ` : ""}
                                        {herstellerangaben?.street ? `${herstellerangaben?.street} | ` : ""}
                                        {herstellerangaben?.city || herstellerangaben.zipCode ? `${herstellerangaben?.zipCode ?? ''} ${herstellerangaben?.city ?? ''} | ` : ""}
                                        {herstellerangaben?.phone ? `Tel: ${herstellerangaben.phone} | ` : ""}
                                        {herstellerangaben?.email ? <>E-Mail: <ExternalLink to={`mailto:${herstellerangaben.email}`}>{herstellerangaben.email}</ExternalLink> {herstellerangaben.homepage && ' | '} </> : ""}
                                        {herstellerangaben?.homepage ? <>Webseite: <ExternalLink to={`${herstellerangaben.homepage}`}>{herstellerangaben.homepage}</ExternalLink> </> : ""}
                                    </span>
                                </div>
                            )}
                        </div>
                        <div>
                            <div className="uk-child-width-1-1 uk-grid-small" data-uk-grid="">
                                {(tireDetail.onlineLieferweg || tireDetail.selectedBezugsquelle.onlineVK !== null) && (
                                    <QuantityBox
                                        addReifen={addReifen}
                                        tire={tireDetail}
                                        price={tireDetail.selectedBezugsquelle.onlineVK}
                                        lieferweg={tireDetail.onlineLieferweg}
                                        online
                                        isFreeShipping={isTecar}
                                        setSelect={handleSelect}
                                        isSelected={isOnline}
                                        quantity={quantity}
                                        isNoa={isNoa}
                                        isOfferActive={isOfferActive}
                                    />
                                )}
                                {(tireDetail.pickupLieferweg || tireDetail.selectedBezugsquelle.vk_preis !== null) && !markenStandort.isTechno && (
                                    <QuantityBox
                                        addReifen={addReifen}
                                        tire={tireDetail}
                                        price={tireDetail.selectedBezugsquelle.vk_preis}
                                        lieferweg={tireDetail.pickupLieferweg}
                                        isFreeShipping={isTecar} setSelect={handleSelect}
                                        isSelected={!isOnline}
                                        quantity={quantity}
                                        isNoa={isNoa}
                                        isOfferActive={isOfferActive}
                                    />
                                )}
                                <div className='uk-grid-small uk-flex-middle uk-padding-remove uk-margin-auto' data-uk-grid="">
                                    <div className="uk-width-1-2@l uk-width-auto uk-flex uk-flex-left@s">
                                        <div className="uk-form-controls">
                                            <QuantityInput
                                                initialValue={1}
                                                minValue={1}
                                                maxValue={(!tireDetail.stock || tireDetail.stock > 999) ? 1111 : tireDetail.stock}
                                                onChange={handleQuantityInputChange}
                                                ariaLabel={`Menge festlegen. Minimum: 1, Maximum: ${(!tireDetail.stock || tireDetail.stock > 999) ? 1111 : tireDetail.stock}`}

                                            />
                                        </div>
                                    </div>
                                    <div className="uk-width-1-3 uk-flex uk-flex-column uk-text-center uk-text-right@s uk-width-expand uk-margin-remove-top@s">
                                        <Button disabled={soldOut} onClick={() => handleAddToCart({ quantity, buttonType: isOnline ? 'addToCart' : 'reserve' })} ariaLabel={isOnline ? 'Zum Warenkorb hinzufügen' : 'RESERVIEREN & ABHOLEN'}>{isOnline ? 'Zum Warenkorb hinzufügen' : 'RESERVIEREN & ABHOLEN'}</Button>
                                    </div>
                                </div>
                                <div className='uk-text-left'>
                                    {(tireDetail.abcCategory === 'C') && (
                                        <div className="uk-text-small" style={{ color: 'var(--shop-main)' }}>
                                            Max. Bestellmenge: 4
                                        </div>
                                    )}
                                    {(tireDetail.abcCategory !== 'C' && tireDetail.stockkeeping && tireDetail.stock > 0) && (
                                        <div className="uk-text-small" style={{ color: 'var(--shop-main)' }}>
                                            Max. Bestellmenge: {tireDetail.stock}
                                        </div>
                                    )}
                                </div>
                                {tireDetail.energyLabelUrl && (
                                    <div className='energy-label-box'>
                                        <div className="energy-label-header">
                                            <div className='energy-label-title uk-text-bold uk-text-large'>EU-Reifenlabel-Werte</div>
                                            <TireInformationModal tire={tireDetail} adjusted={false} />
                                        </div>
                                        <div data-uk-grid="" className="uk-grid-small uk-child-width-expand@s">
                                            <TireEnergyLabelLinks tire={tireDetail} />
                                        </div>
                                    </div>
                                )}
                                <div>
                                    <table className="uk-table uk-table-striped uk-table-small uk-text-left">
                                        <tbody>
                                            <tr>
                                                <td>Hersteller</td>
                                                <td>{tireDetail.hersteller}</td>
                                            </tr>
                                            {tireDetail.profil && (
                                                <tr>
                                                    <td>Profil</td>
                                                    <td>{tireDetail.profil}</td>
                                                </tr>
                                            )}
                                            <tr>
                                                <td>Größe</td>
                                                {tireDetail.tireSize ? (
                                                    <td>{tireDetail.tireSize}</td>
                                                ) : (
                                                    <td>{tireDetail.bezeichnung}</td>
                                                )}
                                            </tr>
                                            <tr>
                                                <td>Geschwindigkeitsindex</td>
                                                <td>
                                                    {tireDetail.speedindex} bis {speedIndexToSpeed[tireDetail.speedindex]} km/h
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Loadindex</td>
                                                <td>{tireDetail.loadindex}</td>
                                            </tr>
                                            <tr>
                                                <td>Kategorie</td>
                                                {tireDetail.categoryType ? (
                                                    <td>{tireDetail.categoryType}</td>
                                                ) : (
                                                    <td>{tireDetail.warengruppe}</td>
                                                )}
                                            </tr>
                                            {additionalInformation && (
                                                <tr>
                                                    <td>Zusatzinformationen</td>
                                                    <td>
                                                        <div data-uk-tooltip={additionalInformation.tooltip}>
                                                            <i className="fa fa-info-circle" aria-hidden="true" />{' '}
                                                            {additionalInformation.label}
                                                        </div>
                                                    </td>
                                                </tr>
                                            )}
                                            <tr>
                                                <td>Demontierte Reifen</td>
                                                <td>
                                                    {tireDetail?.additionalInfo?.demo ? 'Ja' : 'Nein'}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <p className="uk-text-muted uk-text-left">Lieferung ohne Felge</p>
                                </div>
                                <div>
                                    {!tireDetail.energyLabelUrl && (
                                        <ul data-uk-accordion="">
                                            <li className="uk-open">
                                                <Anchor className="uk-accordion-title">EU-Reifenlabel</Anchor>
                                                <div className="uk-accordion-content">
                                                    <LegacyTireLabel tireDetails={tireDetail} />
                                                </div>
                                            </li>
                                        </ul>
                                    )}
                                </div>
                                {herstellerangaben && isMobile && (
                                    <div className='uk-margin-large-bottom'>
                                        <span><strong>Herstellerangaben:</strong> </span>
                                        <span>
                                            {herstellerangaben?.firma ? `${herstellerangaben?.firma} | ` : ""}
                                            {herstellerangaben?.street ? `${herstellerangaben?.street} | ` : ""}
                                            {herstellerangaben?.city || herstellerangaben.zipCode ? `${herstellerangaben?.zipCode ?? ''} ${herstellerangaben?.city ?? ''} | ` : ""}
                                            {herstellerangaben?.phone ? `Tel: ${herstellerangaben.phone} | ` : ""}
                                            {herstellerangaben?.email ? <>E-Mail: <ExternalLink to={`mailto:${herstellerangaben.email}`}>{herstellerangaben.email}</ExternalLink> {herstellerangaben.homepage && ' | '} </> : ""}
                                            {herstellerangaben?.homepage ? <>Webseite: <ExternalLink to={`${herstellerangaben.homepage}`}>{herstellerangaben.homepage}</ExternalLink> </> : ""}
                                        </span>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}


export default MerklistenTireDetail;